<template>
  <div class="flex xl:flex-col flex-col sm:flex-row gap-4">
    <div v-for="i in 3" :key="i" class="flex-1">
      <div
        class="
          bg-gray-100 bg-opacity-50
          border border-gray-200
          flex flex-row
          rounded-md
          items-center
          px-4
          py-8
          gap-4
          shadow-sm
          relative
          animate-pulse
        "
      >
        <div
          class="
            w-10
            h-10
            bg-gray-300
            border border-gray-200
            flex
            items-center
            justify-center
            rounded
          "
        ></div>

        <div class="flex flex-col gap-2 flex-1">
          <div class="h-3 bg-gray-300 rounded w-3/4"></div>

          <div class="h-5 bg-gray-400 rounded w-1/2"></div>
        </div>

        <div
          v-if="i !== 3"
          class="absolute left-4 bottom-4 h-5 w-12 bg-gray-300 rounded-xl"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCardBox',
}
</script>

<style scoped>
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
